import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaUsers, FaUserPlus, FaMoneyBillWave, FaChartLine,
  FaSearch, FaEdit, FaCreditCard, FaHistory,
  FaTachometerAlt, FaCheckCircle, FaTimesCircle,
  FaChartBar, FaUserShield, FaFileContract,
  FaCog, FaBell, FaSignOutAlt, FaGlobe,
  FaLightbulb, FaRobot, FaHandHoldingUsd,
  FaProjectDiagram, FaRegNewspaper, FaReceipt,
  FaUser, FaPlus, FaTrash, FaEye, FaBars, FaTimes, FaCalendarAlt,FaKey
} from 'react-icons/fa';

import AdminProofs from './AdminProofs';
import AddProduct from './AddProduct';
import AddRewards from './AddRewards';
import DailyRewards from './DailyRewards';
import InvestmentManagement from './InvestmentManagement';
import PasswordResetModal from './PasswordResetModal';
import axios from 'axios';
import { format, parseISO } from 'date-fns';
import { useAuth } from '../security/security/AuthContext';
import { FaWhatsapp } from 'react-icons/fa';
import ExpenseManagement from './ExpenseManagement';
import { FaAddressBook } from 'react-icons/fa';
import ContactUpload from './ContactUpload';

import { CSVLink } from 'react-csv';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const Admin = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [selectedUser, setSelectedUser] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [editedBalance, setEditedBalance] = useState('');
  const [notifications, setNotifications] = useState(3);
  const [deposits, setDeposits] = useState([]);
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(1550);
  const { userDetails, token, updateUserDetails } = useAuth();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [securityCode, setSecurityCode] = useState('');
  const [showExportModal, setShowExportModal] = useState(false);
  const [exportError, setExportError] = useState('');
  const [exportFormat, setExportFormat] = useState('csv');


  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const authContext = useAuth();
  const [approvedWithdrawals, setApprovedWithdrawals] = useState(0);
  
    const indexOfLastItem = (currentPage + 1) * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

    const [showPasswordReset, setShowPasswordReset] = useState(false);
    const [selectedUserForPassword, setSelectedUserForPassword] = useState(null);
  

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 992);


  const [dashboardStats, setDashboardStats] = useState({
    totalUsers: 0,
    todaySignups: 0,
    todayTransactions: 0,
    yesterdayTransactions: 0,
    totalRevenue: 0,
    yesterdaySignups: 0,
    totalApprovedWithdrawals: 0
  });
  
  const [recentTransactions, setRecentTransactions] = useState([]);


  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 992);
      if (window.innerWidth > 992) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };


  const handleMenuClick = (tab) => {
    setActiveTab(tab);
    if (isMobileView) {
      setIsSidebarOpen(false);
    }
  };

  useEffect(() => {
      fetchApprovedWithdrawals();
    }, []);


  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        const [statsResponse, transactionsResponse, withdrawalsResponse] = await Promise.all([
          axios.get('https://api.visiontech2030.com/api/admin/dashboard/stats', {
            headers: { Authorization: token }
          }),
          axios.get('https://api.visiontech2030.com/api/admin/transactions/recent', {
            headers: { Authorization: token }
          }),
          axios.get('https://api.visiontech2030.com/api/admin/withdrawals?status=APPROVED', {
            headers: { Authorization: token }
          })
        ]);
    
        const totalApprovedWithdrawals = withdrawalsResponse.data
          .reduce((sum, withdrawal) => sum + withdrawal.requestedAmount, 0);
    
        // Sort recent transactions by ID in descending order
        const sortedTransactions = transactionsResponse.data
          .sort((a, b) => b.id - a.id);
    
        setDashboardStats({
          ...statsResponse.data,
          totalApprovedWithdrawals
        });
        setRecentTransactions(sortedTransactions);
      } catch (err) {
        setError('Failed to load dashboard data');
        console.error('Error fetching dashboard data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);
  

  function logout() {
    authContext.logout();
    navigate('/admin/main/login/1/main/1');
  }

  function whatsapp() {
    navigate('/whatsapp');
  }

  useEffect(() => {
    fetchDeposits();
    fetchWithdrawals();
  }, [currentPage]);

  useEffect(() => {
    if (activeTab === 'users') {
      fetchUsers();
    }
  }, [activeTab]);

  const fetchUsers = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get('https://api.visiontech2030.com/api/admin/users', {
        headers: { Authorization: token }
      });
  
      // Sort the users by ID in descending order
      const sortedUsers = response.data.sort((a, b) => b.id - a.id);
  
      setUsers(sortedUsers);
      setFilteredUsers(sortedUsers);
    } catch (error) {
      setError('Failed to fetch users');
      console.error('Error fetching users:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (searchTerm) => {
    setSearchTerm(searchTerm);
    if (!searchTerm.trim()) {
      setFilteredUsers(users);
      return;
    }

    const searchTermLower = searchTerm.toLowerCase();
    const filtered = users.filter(user => 
      user.fullName.toLowerCase().includes(searchTermLower) ||
      user.email.toLowerCase().includes(searchTermLower) ||
      user.mobile.includes(searchTerm)
    );
    setFilteredUsers(filtered);
  };


  const formatMobileForExport = (mobile) => {
    if (!mobile) return 'N/A';
    
    // Clean the number by removing any non-digit characters
    const cleanNumber = mobile.replace(/\D/g, '');
    
    // If number starts with 254, remove 254 and add 0
    if (cleanNumber.startsWith('254')) {
      return `0${cleanNumber.slice(3)}`;
    }
    
    // If already starts with 07 or 01, keep as is
    if (cleanNumber.startsWith('07') || cleanNumber.startsWith('01')) {
      return cleanNumber;
    }
    
    // For any other format, just return as is
    return cleanNumber;
  };


  const handleExportContacts = () => {
    // Extract mobile numbers and format them according to the requirements
    const contacts = users.map(user => ({
      Mobile: formatMobileForExport(user.mobile)
    }));
    
    // Create Excel file
    const worksheet = XLSX.utils.json_to_sheet(contacts);
    
    // Set column width
    const columnWidths = [
      { wch: 20 }  // Mobile
    ];
    worksheet['!cols'] = columnWidths;
    
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'User Mobile Numbers');
    
    // Generate Excel file and download
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(data, `vision_tech_mobile_numbers_${new Date().toISOString().split('T')[0]}.xlsx`);
  };


  const renderExportModal = () => (
    <div 
      className="adminpage-modal-overlay"
      onClick={(e) => {
        // Only close if clicking directly on the overlay (not its children)
        if (e.target === e.currentTarget) {
          setShowExportModal(false);
          setSecurityCode('');
          setExportError('');
        }
      }}
    >
      <div 
        className="adminpage-modal"
        onClick={(e) => e.stopPropagation()} // Prevent clicks inside modal from closing it
      >
        <div className="adminpage-modal-header">
          <h5>Export Mobile Numbers</h5>
          <button 
            className="adminpage-modal-close" 
            onClick={() => {
              setShowExportModal(false);
              setSecurityCode('');
              setExportError('');
            }}
          >×</button>
        </div>
        <div className="adminpage-modal-body">
          <div className="adminpage-form-group">
            <label>Security Code</label>
            <input 
              type="password" 
              value={securityCode} 
              onChange={(e) => setSecurityCode(e.target.value)}
              placeholder="Enter security code"
            />
            {exportError && <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '4px' }}>{exportError}</div>}
          </div>
          <div className="adminpage-form-group">
            <label>Export Format</label>
            <select 
              value={exportFormat} 
              onChange={(e) => setExportFormat(e.target.value)}
            >
              <option value="csv">CSV</option>
              <option value="excel">Excel</option>
            </select>
          </div>
        </div>
        <div className="adminpage-modal-footer">
          <button 
            className="adminpage-btn-light" 
            onClick={() => setShowExportModal(false)}
          >
            Cancel
          </button>
          <button 
            className="adminpage-btn-primary" 
            onClick={handleExportContacts}
          >
            Export Mobile Numbers
          </button>
        </div>
      </div>
    </div>
  );

 

  const handleUpdateUser = async (userId, updatedData) => {
    try {
      setIsLoading(true);
      const requestData = {
        ...updatedData,
        isEnabled: true, // Always send true for enabled
        mobile: selectedUser.mobile,
        wallet: parseFloat(updatedData.wallet),
        accountStatus: updatedData.accountStatus
      };
  
      const response = await axios.put(
        `https://api.visiontech2030.com/api/admin/users/${userId}`,
        requestData,
        { headers: { Authorization: token } }
      );
  
      // Update the local state with the response data
      const updatedUsers = users.map(user =>
        user.id === userId ? {
          ...user,
          ...response.data,
          isEnabled: true // Ensure it's always enabled
        } : user
      );
  
      setUsers(updatedUsers);
      setFilteredUsers(updatedUsers);
      setEditMode(false);
      setSelectedUser(null);
  
      alert('User updated successfully');
    } catch (error) {
      setError('Failed to update user: ' + (error.response?.data?.message || error.message));
      console.error('Error updating user:', error);
    } finally {
      setIsLoading(false);
    }
  };
  
  // Updated handleEditUser function
  const handleEditUser = (user) => {
    setSelectedUser({
      ...user,
      mobile: user.mobile || '',
      isEnabled: true // Always set to true
    });
    setEditedBalance(user.wallet?.toString() || '0');
    setEditMode(true);
  };


  // Updated fetchDeposits function with error handling and data validation
  const fetchDeposits = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://api.visiontech2030.com/api/admin/deposits?page=${currentPage}&size=${itemsPerPage}`, 
        { headers: { Authorization: token } }
      );
      
      // Validate and transform the data, then sort by ID in descending order
      const validatedDeposits = response.data
        .map(deposit => ({
          ...deposit,
          amount: deposit.amount || 0,
          transactionDate: deposit.transactionDate || new Date().toISOString(),
          status: deposit.status || 'PENDING',
          mpesaReceiptNumber: deposit.mpesaReceiptNumber || 'N/A',
          phoneNumber: deposit.phoneNumber || 'N/A'
        }))
        .sort((a, b) => b.id - a.id); // Sort in descending order
      
      setDeposits(validatedDeposits);
    } catch (error) {
      console.error('Error fetching deposits:', error);
      setError('Failed to fetch deposits');
      setDeposits([]);
    } finally {
      setLoading(false);
    }
  };


  const fetchApprovedWithdrawals = async () => {
    try {
      const response = await axios.get('https://api.visiontech2030.com/api/admin/withdrawals?status=APPROVED', {
        headers: { Authorization: token }
      });
      const totalWithdrawals = response.data.reduce((sum, withdrawal) => sum + withdrawal.amountToReceive, 0);
      setApprovedWithdrawals(totalWithdrawals);
    } catch (error) {
      console.error('Error fetching approved withdrawals:', error);
    }
  };
  

  // Updated fetchWithdrawals function with error handling and data validation
  const fetchWithdrawals = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://api.visiontech2030.com/api/admin/withdrawals?page=${currentPage}&size=${itemsPerPage}`, 
        { headers: { Authorization: token } }
      );
      
      // Validate and transform the data, then sort by ID in descending order
          const validatedWithdrawals = response.data
      .map(withdrawal => ({
        ...withdrawal,
        requestedAmount: withdrawal.requestedAmount || 0,
        amountToReceive: withdrawal.amountToReceive || 0,
        requestTime: withdrawal.requestTime || new Date().toISOString(),
        withdrawalStatus: withdrawal.withdrawalStatus || 'PENDING',
        orderNumber: withdrawal.orderNumber || 'N/A',
        email: withdrawal.email || 'N/A',
        mobile: withdrawal.mobile || 'N/A'
      }))
      .sort((a, b) => b.id - a.id); // Sort in descending order
          
      setWithdrawals(validatedWithdrawals);
    } catch (error) {
      console.error('Error fetching withdrawals:', error);
      setError('Failed to fetch withdrawals');
      setWithdrawals([]);
    } finally {
      setLoading(false);
    }
  };

  
  const handleDeleteTransaction = async (id) => {
    if (window.confirm('Are you sure you want to delete this transaction?')) {
      try {
        await axios.delete(`https://api.visiontech2030.com/api/admin/transactions/${id}`, {
          headers: { Authorization: token }
        });
        fetchDeposits(); // Refresh the list
      } catch (error) {
        console.error('Error deleting transaction:', error);
      }
    }
  };
  
  const handleApproveWithdrawal = async (id) => {
    try {
      await axios.put(`https://api.visiontech2030.com/api/admin/withdrawals/${id}/approve`, null, {
        headers: { Authorization: token }
      });
      fetchWithdrawals(); // Refresh the list
    } catch (error) {
      console.error('Error approving withdrawal:', error);
    }
  };
  
  const handleDeclineWithdrawal = async (id) => {
    if (window.confirm('Are you sure you want to decline this withdrawal? The amount will be refunded to the user.')) {
      try {
        await axios.put(`https://api.visiontech2030.com/api/admin/withdrawals/${id}/decline`, null, {
          headers: { Authorization: token }
        });
        fetchWithdrawals(); // Refresh the list
      } catch (error) {
        console.error('Error declining withdrawal:', error);
      }
    }
  };


  // Mock data
  useEffect(() => {
    setUsers([
      { id: 1, name: 'John Doe', email: 'john@example.com', wallet: 5000, joinDate: '2024-10-29', status: 'active', investmentPlan: 'Premium', totalInvestments: 25000 },
      { id: 2, name: 'Jane Smith', email: 'jane@example.com', wallet: 3000, joinDate: '2024-10-30', status: 'active', investmentPlan: 'Standard', totalInvestments: 15000 }
    ]);

    setDeposits([
      { id: 1, userId: 1, amount: 1000, date: '2024-10-30', status: 'completed', method: 'Bank Transfer', reference: 'DEP001' },
      { id: 2, userId: 2, amount: 2000, date: '2024-10-30', status: 'pending', method: 'Credit Card', reference: 'DEP002' }
    ]);

    setWithdrawals([
      { id: 1, userId: 1, amount: 500, date: '2024-10-30', status: 'pending', method: 'Bank Transfer', reference: 'WIT001' },
      { id: 2, userId: 2, amount: 1000, date: '2024-10-30', status: 'completed', method: 'Wire Transfer', reference: 'WIT002' }
    ]);
  }, []);



  const handlePasswordReset = async (userId, newPassword) => {
    try {
      await axios.put(
        `https://api.visiontech2030.com/api/admin/users/${userId}/reset-password`,
        { newPassword },
        { headers: { Authorization: token } }
      );
      // Show success message or handle UI updates
    } catch (error) {
      console.error('Error resetting password:', error);
      throw error; // Let the modal component handle the error
    }
  };
  

  const renderDashboard = () => (
    <>
    <div className="adminpage-dashboard">
      <div className="adminpage-stats-grid">
        <div className="adminpage-stat-card adminpage-gradient-green">
          <div className="adminpage-stat-content">
            <div className="adminpage-stat-info">
              <h6>Total Users</h6>
              <h2>{dashboardStats.totalUsers.toLocaleString()}</h2>
            </div>
            <div className="adminpage-stat-icon">
              <FaUsers size={30} />
            </div>
          </div>
        </div>

        <div className="adminpage-stat-card adminpage-gradient-blue">
          <div className="adminpage-stat-content">
            <div className="adminpage-stat-info">
              <h6>Today's Signups</h6>
              <h2>{dashboardStats.todaySignups}</h2>
            </div>
            <div className="adminpage-stat-icon">
              <FaUserPlus size={30} />
            </div>
          </div>
        </div>

        <div className="adminpage-stat-card adminpage-gradient-blue">
          <div className="adminpage-stat-content">
            <div className="adminpage-stat-info">
              <h6>Yesterday's Signups</h6>
              <h2>{dashboardStats.yesterdaySignups || 0}</h2>
            </div>
            <div className="adminpage-stat-icon">
              <FaCalendarAlt size={30} />
            </div>
          </div>
        </div>

        <div className="adminpage-stat-card adminpage-gradient-purple">
        <div className="adminpage-stat-content">
          <div className="adminpage-stat-info">
            <h6>Yesterday's Transactions</h6>
            <h2>KSH {dashboardStats.yesterdayTransactions.toLocaleString()}</h2>
          </div>
          <div className="adminpage-stat-icon">
            <FaHistory size={30} />
          </div>
        </div>
      </div>

        <div className="adminpage-stat-card adminpage-gradient-purple">
          <div className="adminpage-stat-content">
            <div className="adminpage-stat-info">
              <h6>Today's Transactions</h6>
              <h2>KSH {dashboardStats.todayTransactions.toLocaleString()}</h2>
            </div>
            <div className="adminpage-stat-icon">
              <FaHandHoldingUsd size={30} />
            </div>
          </div>
        </div>

        <div className="adminpage-stat-card adminpage-gradient-orange">
          <div className="adminpage-stat-content">
            <div className="adminpage-stat-info">
              <h6>Total Revenue</h6>
              <h2>KSH {dashboardStats.totalRevenue.toLocaleString()}</h2>
            </div>
            <div className="adminpage-stat-icon">
              <FaChartLine size={30} />
            </div>
          </div>
        </div>

        <div className="adminpage-stat-card adminpage-gradient-orange">
          <div className="adminpage-stat-content">
            <div className="adminpage-stat-info">
              <h6>Total Approved Withdrawals</h6>
              <h2>KSH {approvedWithdrawals.toLocaleString()}</h2>
            </div>
            <div className="adminpage-stat-icon">
              <FaMoneyBillWave size={30} />
            </div>
          </div>
        </div>
      </div>



      <div className="adminpage-content-grid">
        <div className="adminpage-card adminpage-transactions">
          <div className="adminpage-card-header">
            <h5>Recent Transactions</h5>
          </div>
          <div className="adminpage-card-body">
            <table className="adminpage-table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Receipt Number</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {recentTransactions.map((transaction) => (
                  <tr key={transaction.id}>
                    <td>
                      <div className="adminpage-user-info">
                        <div className="adminpage-user-avatar">
                          <FaUser />
                          <div className="adminpage-user-reference">{transaction.phoneNumber}</div>
                        </div>
                      </div>
                    </td>
                    <td>KSH {transaction.amount.toLocaleString()}</td>
                    <td>
                      <span className={`adminpage-status adminpage-status-${transaction.status.toLowerCase()}`}>
                        {transaction.status}
                      </span>
                    </td>
                    <td>{transaction.mpesaReceiptNumber}</td>
                    <td>{format(new Date(transaction.transactionDate), 'PPp')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    </>
  );

  const renderDeposits = () => (
    <div className="adminpage-card">
      <div className="adminpage-card-header">
        <div className="adminpage-header-content">
          <h5 className="adminpage-title">Recent Deposits</h5>
          <div className="adminpage-button-group">
            <button className="adminpage-button adminpage-button-outline">
              <FaFileContract className="adminpage-icon" /> Export Report
            </button>
            <button className="adminpage-button adminpage-button-primary">
              <FaPlus className="adminpage-icon" /> New Deposit
            </button>
          </div>
        </div>
      </div>
      <div className="adminpage-card-body">
        {loading ? (
          <div className="adminpage-loading">Loading...</div>
        ) : error ? (
          <div className="adminpage-error">{error}</div>
        ) : (
          <div className="adminpage-table-container">
            <table className="adminpage-table">
               <thead>
              <tr>
                <th>Receipt Number</th>
                <th>Phone Number</th>
                <th>Amount</th>
                <th>Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
              <tbody>
                {deposits.map(deposit => (
                  <tr key={deposit.id}>
                    <td>{deposit.mpesaReceiptNumber}</td>
                    <td>{deposit.phoneNumber}</td>
                    <td>KSH {deposit.amount.toLocaleString()}</td>
                    <td>
                      {/* Safely format the date */}
                      {format(parseISO(deposit.transactionDate), 'PPp')}
                    </td>
                    <td>
                      <span className={`adminpage-status adminpage-status-${deposit.status.toLowerCase()}`}>
                        {deposit.status}
                      </span>
                    </td>
                    <td>
                      <div className="adminpage-actions">
                        <button 
                          className="adminpage-action-button adminpage-delete"
                          onClick={() => handleDeleteTransaction(deposit.id)}
                        >
                          <FaTrash /> Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          <div className="adminpage-pagination">
            <button 
              onClick={() => setCurrentPage(prev => Math.max(0, prev - 1))}
              disabled={currentPage === 0}
            >
              Previous
            </button>
            <span>Page {currentPage + 1}</span>
            <button 
              onClick={() => setCurrentPage(prev => prev + 1)}
              disabled={deposits.length < itemsPerPage}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  </div>
  );

  const renderWithdrawals = () => (
    <div className="adminpage-card">
      <div className="adminpage-card-header">
        <div className="adminpage-header-content">
          <h5 className="adminpage-title">Pending Withdrawals</h5>
          <div className="adminpage-button-group">
            <button className="adminpage-button adminpage-button-outline">
              <FaFileContract className="adminpage-icon" /> Export Report
            </button>
          </div>
        </div>
      </div>
      <div className="adminpage-card-body">
      {loading ? (
        <div className="adminpage-loading">Loading...</div>
      ) : (
        <div className="adminpage-table-container">
           <div className="adminpage-pagination">
            <button 
              onClick={() => setCurrentPage(prev => Math.max(0, prev - 1))}
              disabled={currentPage === 0}
            >
              Previous
            </button>
            <span>Page {currentPage + 1}</span>
            <button 
              onClick={() => setCurrentPage(prev => prev + 1)}
              disabled={withdrawals.length < itemsPerPage}
            >
              Next
            </button>
          </div>
          <table className="adminpage-table">
            <thead>
              <tr>
                <th>Order Number</th>
                <th>User</th>
                <th>Amount</th>
                <th>Amount to Receive</th>
                <th>Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
                {withdrawals.map(withdrawal => (
                  <tr key={withdrawal.id}>
                    <td>{withdrawal.orderNumber}</td>
                    <td>
                      <div className="adminpage-user-info">
                        <div className="adminpage-user-details">
                          <div>{withdrawal.email}</div>
                          <div className="adminpage-text-muted">{withdrawal.mobile}</div>
                        </div>
                      </div>
                    </td>
                    <td>KSH {withdrawal.requestedAmount.toLocaleString()}</td>
                    <td>KSH {withdrawal.amountToReceive.toLocaleString()}</td>
                    <td>
                      {/* Safely format the date */}
                      {format(parseISO(withdrawal.requestTime), 'PPp')}
                    </td>
                    <td>
                      <span className={`adminpage-status adminpage-status-${withdrawal.withdrawalStatus.toLowerCase()}`}>
                        {withdrawal.withdrawalStatus}
                      </span>
                    </td>
                    <td>
                      {withdrawal.withdrawalStatus === 'PENDING' && (
                        <div className="adminpage-actions">
                          <button 
                            className="adminpage-action-button adminpage-approve"
                            onClick={() => handleApproveWithdrawal(withdrawal.id)}
                          >
                            <FaCheckCircle /> Approve
                          </button>
                          <button 
                            className="adminpage-action-button adminpage-decline"
                            onClick={() => handleDeclineWithdrawal(withdrawal.id)}
                          >
                            <FaTimesCircle /> Decline
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
          </table>
        </div>
      )}
    </div>
  </div>
  );


  const renderUsers = () => {

    const formatPhoneNumber = (mobile) => {
    if (!mobile) return '';
    
    // Remove any non-digit characters
    const cleanNumber = mobile.replace(/\D/g, '');
    
    // If number starts with 254, keep it as is
    if (cleanNumber.startsWith('254')) {
      return cleanNumber;
    }
    
    // If number starts with 01, remove 01 and add 254
    if (cleanNumber.startsWith('01')) {
      return `2541${cleanNumber.slice(2)}`;
    }
    
    // If number starts with 07, remove 07 and add 254
    if (cleanNumber.startsWith('07')) {
      return `2547${cleanNumber.slice(2)}`;
    }
    
    return cleanNumber;
  };

  const initiateWhatsAppChat = (mobile) => {
    const formattedNumber = formatPhoneNumber(mobile);
    window.open(`https://wa.me/${formattedNumber}`, '_blank');
  };

    
    const handleSuperLogin = async (userId) => {
      try {
        const response = await axios.post(
          `https://api.visiontech2030.com/api/admin/super-login/${userId}`,
          null,
          { headers: { Authorization: token } }
        );
        
        // Store original admin token
        localStorage.setItem('adminToken', token);
        
        // Set new super login token
        const superLoginToken = response.data.access_token;
        localStorage.setItem('token', superLoginToken);
        
        // Store super login state
        localStorage.setItem('isSuperLogin', 'true');
        localStorage.setItem('originalUserId', userId);
        
        // Update auth context
        updateUserDetails(response.data.userDetails);
        
        // Redirect to user dashboard
        navigate('/home');
        
      } catch (error) {
        console.error('Super login failed:', error);
        alert('Failed to access user account. Please try again.');
      }
    };

    return (
      <div className="adminpage-card">
      <div className="adminpage-card-header">
        <div className="adminpage-header-content">
          <h5>User Management</h5>
          <div className="adminpage-header-actions">
            <div className="adminpage-search">
              <input
                type="text"
                placeholder="Search by name, email, or mobile..."
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
              />
              <button className="adminpage-btn-primary">
                <FaSearch />
              </button>
            </div>
            <button 
            className="adminpage-btn-success adminpage-export-btn"
            onClick={handleExportContacts}
          >
            <FaFileContract />.
          </button>
          </div>
        </div>
      </div>
        <div className="adminpage-card-body">
          {isLoading ? (
            <div className="adminpage-loading">Loading...</div>
          ) : error ? (
            <div className="adminpage-error">{error}</div>
          ) : (
            <div className="adminpage-table-container">
              <table className="adminpage-table">
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Mobile</th>
                    <th>WhatsApp</th>
                    <th>Account Status</th>
                    <th>Wallet Balance</th>
                    <th>Created On</th>
                    <th>User_Id</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentUsers.map(user => (
                    <tr key={user.id}>
                      <td>
                        <div className="adminpage-user-info">
                          <div className="adminpage-user-avatar">
                            <FaUser className="adminpage-avatar-icon" />
                          </div>
                          <div className="adminpage-user-details">
                            <div className="adminpage-user-name">{user.fullName}</div>
                            <div className="adminpage-user-email">{user.email}</div>
                          </div>
                        </div>
                      </td>
                      <td>{user.mobile}</td>
                      <td>
                        <button 
                  className="whatsapp-chat-user-chat-button"
                  onClick={() => initiateWhatsAppChat(user.mobile)}
                  disabled={!user.mobile}
                >
                  <FaWhatsapp />
                  Chat Now
                </button>
                        
                      </td>
                      <td>
                        <span className={`adminpage-badge ${user.accountStatus === 'ACTIVE' ? 'adminpage-badge-success' : 'adminpage-badge-warning'}`}>
                          {user.accountStatus}
                        </span>
                      </td>
                      <td>KSH {user.wallet?.toLocaleString()}</td>
                      <td>{format(parseISO(user.createdOn), 'PPp')}</td>
                      <td>User_id_{user.id}</td>
                     <td>
                        <div className="adminpage-actions">
                          <button 
                            className="adminpage-btn-primary adminpage-btn-sm"
                            onClick={() => handleEditUser(user)}
                          >
                            <FaEdit /> Edit
                          </button>
                          <button 
                            className="adminpage-btn-warning adminpage-btn-sm"
                            onClick={() => handleSuperLogin(user.id)}
                          >
                            <FaUserShield /> Super Login
                          </button>
                          <button 
                          className="adminpage-btn-secondary adminpage-btn-sm"
                          onClick={() => {
                            setSelectedUserForPassword(user);
                            setShowPasswordReset(true);
                          }}
                        >
                          <FaKey /> Reset Password
                        </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="adminpage-pagination">
                <button
                  onClick={() => setCurrentPage(prev => Math.max(0, prev - 1))}
                  disabled={currentPage === 0}
                >
                  Previous
                </button>
                <span>Page {currentPage + 1}</span>
                <button
                  onClick={() => setCurrentPage(prev => prev + 1)}
                  disabled={currentUsers.length < itemsPerPage}
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };
  
  return (
    <div className="adminpage-container">
      <aside className={`adminpage-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="adminpage-sidebar-header">
          <h4>Vision Tech 2030</h4>
          {isMobileView && (
            <button className="adminpage-sidebar-close" onClick={toggleSidebar}>
              <FaTimes />
            </button>
          )}
        </div>
        
        <nav className="adminpage-nav">
          {[
            { icon: <FaTachometerAlt />, label: 'Dashboard' },
            { icon: <FaChartLine />, label: 'Investments' },
            { icon: <FaCreditCard />, label: 'Deposits' },
            { icon: <FaMoneyBillWave />, label: 'Withdrawals' },
            { icon: <FaUsers />, label: 'Users' },
            { icon: <FaLightbulb />, label: 'Daily' },
            { icon: <FaReceipt />, label: 'Proofs' },
            { icon: <FaRobot />, label: 'Products' },
            { icon: <FaMoneyBillWave />, label: 'Expenses' },
            { icon: <FaAddressBook />, label: 'Contacts' },
          ].map(item => (
            <button 
              key={item.label}
              className={`adminpage-nav-item ${activeTab === item.label.toLowerCase() ? 'active' : ''}`}
              onClick={() => setActiveTab(item.label.toLowerCase())}
            >
              {item.icon}
              <span>{item.label}</span>
            </button>
          ))}
          <button className="adminpage-logout-btn" onClick={whatsapp}>
            WhatsApp Directory<FaSignOutAlt />
          </button>
        </nav>
        
        <div className="adminpage-sidebar-footer">
          <div className="adminpage-admin-info">
            <div className="adminpage-admin-avatar">
              <FaUserShield />
            </div>
            <div className="adminpage-admin-details">
              <div className="adminpage-admin-name">Admin User</div>
              <div className="adminpage-admin-email">admin@visiontech2030.com</div>
            </div>
          </div>
          <button className="adminpage-logout-btn" onClick={logout}>
            <FaSignOutAlt />
          </button>
        </div>
      </aside>

      {isMobileView && isSidebarOpen && (
        <div 
          className="adminpage-sidebar-overlay"
          onClick={toggleSidebar}
        />
      )}
  
      <main className={`adminpage-main ${isSidebarOpen && !isMobileView ? 'shifted' : ''}`}>
        <header className="adminpage-header">
          <div className="adminpage-header-left">
            <button 
              className="adminpage-mobile-toggle"
              onClick={toggleSidebar}
            >
              <FaBars />
            </button>
            <h5>{activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}</h5>
          </div>
          <div className="adminpage-header-actions">
            <button className="adminpage-notification-btn">
              <FaBell />
              {notifications > 0 && (
                <span className="adminpage-notification-badge">
                  {notifications}
                </span>
              )}
            </button>
            <button className="adminpage-globe-btn">
              <FaGlobe />
            </button>
          </div>
        </header>
  
        <div className="adminpage-content">
          {activeTab === 'dashboard' && renderDashboard()}
          {activeTab === 'deposits' && renderDeposits()}
          {activeTab === 'withdrawals' && renderWithdrawals()}
          {activeTab === 'users' && renderUsers()}
          {activeTab === 'daily' && <DailyRewards />}
          {activeTab === 'proofs' && <AdminProofs />}
          {activeTab === 'products' && <AddProduct />}
          {activeTab === 'rewards' && <AddRewards />}
          {activeTab === 'investments' && <InvestmentManagement  />}
          {activeTab === 'expenses' && <ExpenseManagement />}
          {activeTab === 'contacts' && <ContactUpload token={token} />}
        </div>
      </main>
  
        {editMode && (
          <div className="adminpage-modal-overlay">
            <div className="adminpage-modal">
              <div className="adminpage-modal-header">
                <h5>Edit User Details</h5>
                <button className="adminpage-modal-close" onClick={() => setEditMode(false)}>×</button>
              </div>
              <div className="adminpage-modal-body">
                <div className="adminpage-form-group">
                  <label>Name</label>
                  <input type="text" value={selectedUser?.fullName} disabled />
                </div>
                <div className="adminpage-form-group">
                  <label>Email</label>
                  <input type="email" value={selectedUser?.email} disabled />
                </div>
                <div className="adminpage-form-group">
                <label>Mobile Number</label>
                <input
                  type="tel"
                  value={selectedUser?.mobile || ''}
                  onChange={(e) => setSelectedUser({
                    ...selectedUser,
                    mobile: e.target.value
                  })}
                  placeholder="Enter mobile number"
                />
                </div>
                <div className="adminpage-form-group">
                  <label>Wallet Balance</label>
                  <div className="adminpage-input-group">
                    <span>KSH</span>
                    <input
                      type="number"
                      value={editedBalance}
                      onChange={(e) => setEditedBalance(e.target.value)}
                    />
                  </div>
                </div>
                <div className="adminpage-form-group">
                  <label>Account Status</label>
                  <select 
                    value={selectedUser?.accountStatus} 
                    onChange={(e) => setSelectedUser({
                      ...selectedUser,
                      accountStatus: e.target.value
                    })}
                  >
                    <option value="ACTIVE">Active</option>
                    <option value="INACTIVE">Inactive</option>
                    <option value="SUSPENDED">Suspended</option>
                  </select>
                </div>
                <div className="adminpage-form-group">
                  <label>User Verification</label>
                  <select
                    value="true"
                    onChange={(e) => setSelectedUser({
                      ...selectedUser,
                      isEnabled: true
                    })}
                  >
                    <option value="true">Enable</option>
                  </select>
                </div>
              </div>
              <div className="adminpage-modal-footer">
              <button className="adminpage-btn-light" onClick={() => setEditMode(false)}>
                Cancel
              </button>
              <button 
                  className="adminpage-btn-primary" 
                  onClick={() => handleUpdateUser(selectedUser.id, {
                    wallet: parseFloat(editedBalance),
                    accountStatus: selectedUser.accountStatus,
                    isEnabled: true,
                    mobile: selectedUser.mobile
                  })}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        )}

            {showPasswordReset && selectedUserForPassword && (
              <PasswordResetModal
                user={selectedUserForPassword}
                onClose={() => {
                  setShowPasswordReset(false);
                  setSelectedUserForPassword(null);
                }}
                onPasswordReset={handlePasswordReset}
              />
            )}

        <CSVLink
          id="csvDownloadLink"
          data={users.map(user => ({
            Mobile: formatMobileForExport(user.mobile)
          }))}
          filename={`vision_tech_mobile_numbers_${new Date().toISOString().split('T')[0]}.csv`}
          className="hidden-download-link"
          style={{ display: 'none' }}
        />

{/* Export Modal */}
{showExportModal && renderExportModal()}
    </div>
  );
};

export default Admin;
